import React from "react";
import tw from "twin.macro";
import OrgCard from "./org-card";
import FrontierLogoSvg from "./frontier-logo.svg";
import { Hyperlink } from "../section";

const FrontierCard = tw(OrgCard.Base)`mr-auto`;
const FrontierPiHeading = tw(
  OrgCard.PiHeadingBase
)`border-blue-900 text-blue-900`;

const fsurl = "https://www.frontierscience.org";

const Frontier = () => (
  <FrontierCard>
    <OrgCard.LogoContainer href={fsurl}>
      <OrgCard.Logo src={FrontierLogoSvg} alt="Frontier Science Foundation" />
    </OrgCard.LogoContainer>
    <OrgCard.Body>
      <OrgCard.Paragraph>
        <Hyperlink href={fsurl}>Frontier Science Foundation</Hyperlink> has
        engaged in clinical trials collaboration and support for 40 years,
        providing accurate and cost-effective data management as well as
        statistical software development and maintenance for the collection and
        analysis of data to research networks, pharmaceutical companies and
        investigators.
      </OrgCard.Paragraph>
      <OrgCard.Paragraph>
        Frontier Science has participated in numerous multi-site, multi-trial
        networks including the AIDS Clinical Trials Group (ACTG); the Pediatric
        AIDS Clinical Trials Group and its successor, IMPAACT; the Eastern
        Cooperative Oncology Group (ECOG) and International Breast Cancer Study
        Group (IBCSG) and the Pediatric HIV/AIDS Cohort Study (PHACS).
      </OrgCard.Paragraph>
      <OrgCard.Paragraph>
        Frontier Science collaborates with scientists and technicians in more
        than 800 laboratories, universities and medical centers around the world
        engaged in clinical trials and observational studies.
      </OrgCard.Paragraph>
    </OrgCard.Body>
    <OrgCard.Pi>
      <FrontierPiHeading>Sue Siminski, MS, MBA</FrontierPiHeading>
      <OrgCard.Paragraph>
        Sue Siminski, MS, MBA is the DMACC Sub-PI and Director of the Data
        Management and Reporting Unit. She has been working in clinical trials
        data management and related research activities for more than 30 years
        and currently serves as the Chief Executive Officer of Frontier Science
        Foundation.
      </OrgCard.Paragraph>
    </OrgCard.Pi>
  </FrontierCard>
);

export default Frontier;
